import initialState from './initialState';
import {
  FETCH_ALL_LISTS_INIT,
  FETCH_ALL_LISTS_SUCCESS,
  FETCH_ALL_LISTS_FAILURE,
  FETCH_ALL_ITEMS_BY_LIST_INIT,
  FETCH_ALL_ITEMS_BY_LIST_SUCCESS,
  FETCH_ALL_ITEMS_BY_LIST_FAILURE,
  ACCOUNT_LIST_RESET_LIST_ITEMS,
  ACCOUNT_LIST_ADD_NEW_ITEM_TO_SAVE_OR_DELETE,
  ACCOUNT_LIST_REMOVE_NEW_ITEM_TO_SAVE_OR_DELETE,
  ACCOUNT_LIST_SAVE_ITEMS_CHANGES_INIT,
  ACCOUNT_LIST_SAVE_ITEMS_CHANGES_FAILURE,
  ACCOUNT_LIST_SAVE_ITEMS_CHANGES_SUCCESS,
  ACCOUNT_LIST_CREATE_LIST_INIT,
  ACCOUNT_LIST_CREATE_LIST_SUCCESS,
  ACCOUNT_LIST_CREATE_LIST_FAILURE,
  ACCOUNT_LIST_DELETE_LIST_INIT,
  ACCOUNT_LIST_DELETE_LIST_SUCCESS,
  ACCOUNT_LIST_DELETE_LIST_FAILURE,
  RESET_ACCOUNT_LIST
} from '../../actions/account_list/types';

export default function accountList(state = initialState, action) {
  switch (action.type) {
    // LISTS
    case FETCH_ALL_LISTS_INIT:
      return {
        ...state,
        lists: {
          ...state.lists,
          loading: true,
          datos: [],
          error: null,
          status: null,
          selected: {
            listId:null,
            listName: ""
          }
        },
        items: {
          ...state.items,
          loading: false,
          status: null,
          datos: [],
          error: null,
          newDataToSave:false
        }
      };
    case FETCH_ALL_LISTS_FAILURE:
      return {
        ...state,
        lists: {
          ...state.lists,
          loading: false,
          datos: [],
          error: action.payload,
          status: action.payload.status
        }
      };
    case FETCH_ALL_LISTS_SUCCESS:
      return {
        ...state,
        lists: {
          ...state.lists,
          loading: false,
          datos: action.payload.data.response,
          error: null,
          status: action.payload.status
        }
      };
    //ITEMS
    case FETCH_ALL_ITEMS_BY_LIST_INIT:
      return {
        ...state,
        lists: {
          ...state.lists,
          selected:{
            listId:null,
            listName: ""
          }
        },
        items: {
          ...state.items,
          loading: true,
          newDataToSave:false,
          status: null,
          datos: [],
          error: null
        }
      };
    case ACCOUNT_LIST_CREATE_LIST_INIT:
      return {
        ...state,
        listCreate: {
          ...state.listCreate, 
          error: null,
          loading: true
        }
      };
    case ACCOUNT_LIST_CREATE_LIST_SUCCESS:
      return {
        ...state,
        listCreate: {
          ...state.listCreate, 
          datos: action.payload.data,
          error: null,
          loading: false,
          status: action.payload.status
        }
      };
    case ACCOUNT_LIST_CREATE_LIST_FAILURE:
      return {
        ...state,
        listCreate: {
          ...state.listCreate, 
          error: action.payload,
          loading: false,
          status: 500,
        }
      };
    case ACCOUNT_LIST_DELETE_LIST_INIT:
      return {
        ...state,
        listDelete: {
          ...state.listDelete, 
          error: null,
          loading: true
        }
      };
    case ACCOUNT_LIST_DELETE_LIST_SUCCESS:
      return {
        ...state,
        listDelete: {
          ...state.listDelete, 
          datos: action.payload.data,
          error: null,
          loading: false,
          status: action.payload.status
        }
      };
    case ACCOUNT_LIST_DELETE_LIST_FAILURE:
      return {
        ...state,
        listDelete: {
          ...state.listDelete, 
          error: action.payload,
          loading: false,
          status: 500
        }
      };
    case FETCH_ALL_ITEMS_BY_LIST_FAILURE:
      return {
        ...state,
        items: {
          ...state.items,
          loading: false,
          error: action.payload,
          status: action.payload.status,
          datos: []
        }
      };
    case FETCH_ALL_ITEMS_BY_LIST_SUCCESS:
      return {
        ...state,
        lists: {
          ...state.lists,
          selected: action.payload.selectedList
        },
        items: {
          ...state.items,
          loading: false,
          error: null,
          status: action.payload.data.status,
          datos: action.payload.data.data.response
        }
      };
    case ACCOUNT_LIST_RESET_LIST_ITEMS:
      return {
        ...state,
        lists: {
          ...state.lists,
          selected:{
            listId:null,
            listName: ""
          }
        },
        items: {
          ...state.items,
          loading: false,
          status: null,
          datos: [],
          error: null,
          newDataToSave:false
        }
      };
    /* ITEM */
    case ACCOUNT_LIST_ADD_NEW_ITEM_TO_SAVE_OR_DELETE:
      action.payload.listId = state.lists.selected.listId;
      var itemsToCreate = [];
      var itemsCreated = state.items.datos;
      if(action.payload.id == null) {
        itemsToCreate.push(action.payload);
      }
      else if(action.payload.id && action.payload.delete) {
        itemsCreated = state.items.datos.map(item => {
          if(item.id==action.payload.id) {
            return {...item,delete:true,update:false};
          }
          else {
            return item;
          }
        });
      }
      else if(action.payload.id && action.payload.update) {
        itemsCreated = state.items.datos.map(item => {
          if(item.id==action.payload.id) {
            return {...item,editedValue:action.payload.editedValue,
              delete:false,update:true};
          }
          else {
            return item;
          }
        });
      }
      return {
        ...state,
        items: {
          ...state.items,
          datos: [...itemsCreated, ...itemsToCreate],
          newDataToSave:true
        }
      };
    case ACCOUNT_LIST_REMOVE_NEW_ITEM_TO_SAVE_OR_DELETE:
      var newItemsArr = state.items.datos;
      var newDataToSave = false;
      
      if(action.payload.id == null) {
        newItemsArr = newItemsArr.filter(item => {
          return (item.name != action.payload.name || item.id!=null);
        });
      }
      else if(action.payload.id && action.payload.delete) {
        newItemsArr = newItemsArr.map(item => {
          if(item.id==action.payload.id) {
            return {...item,delete:false};
          }
          else {
            return item;
          }
        });
      }
      else if(action.payload.id && action.payload.update) {
        newItemsArr = newItemsArr.map(item => {
          if(item.id==action.payload.id) {
            return {...item,update:false};
          }
          else {
            return item;
          }
        });
      }
      newItemsArr.forEach(item => {
        if(item.id==null || item.delete) {
          newDataToSave = true;
        }
      });

      return {
        ...state,
        items: {
          ...state.items,
          datos: newItemsArr,
          newDataToSave:newDataToSave
        }
      };
    case ACCOUNT_LIST_SAVE_ITEMS_CHANGES_INIT:
      return {
        ...state,
        itemsChanges: {
          ...state.itemsChanges,
          loading: true,
          error: null,
          status: null,
          datos: [],
          itemsNotSaved: []
        },
        items: {
          ...state.items,
          loading: true
        }
      };
    case ACCOUNT_LIST_SAVE_ITEMS_CHANGES_FAILURE:
      return {
        ...state,
        itemsChanges: {
          ...state.itemsChanges,
          loading: false,
          datos: [],
          error: action.payload,
          status: action.payload.status
        },
        items: {
          ...state.items,
          loading: false
        }
      };
    case ACCOUNT_LIST_SAVE_ITEMS_CHANGES_SUCCESS:
      var itemsNotSaved = [];
      var itemsSaved = [];
      action.payload.data.forEach((item,i) => {
        if(item.status !== 200) {
          if(item.data && item.response 
            && item.response.error && item.response.error.code) {
            item.data.errorCode = item.response.error.code;
          }
          itemsNotSaved.push(item.data);
        }
        else {
          itemsSaved.push(item.data);
        }
      });
      return {
        ...state,
        itemsChanges: {
          ...state.itemsChanges,
          loading: false,
          datos: itemsSaved,
          error: null,
          status: action.payload.status,
          itemsNotSaved: itemsNotSaved
        },
        items: {
          ...state.items,
          loading: false
        }
      };
    case RESET_ACCOUNT_LIST:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/account_list/index.js